import request from "@/utils/request";
const BASE_API = process.env.VUE_APP_BASE_API;

export function getFxVisitCount(param) {
  return request({
    url: `${BASE_API}/api/linsten/fx_visit_count`,
    method: "get",
    params: param,
  })
}

export function putModuleCount(data) {
  return request({
    url: `${BASE_API}/api/sms/modulecount`,
    method: "put",
    data: data
  })
}
